// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","newsletterSelectionWrapper":"NewsletterSelection_newsletterSelectionWrapper__PCnwr"};